// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === 7888) return "css/design_system-89a3926ec7475bbd.css";
if (chunkId === 6978) return "css/6978-c586a124cd2c026d.css";
if (chunkId === 1710) return "css/1710-0573bf035ed5dce9.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {1718: "25e43d52410aceac",2429: "b48e6c63aa23489f",3641: "91ecc8e70b90fc55",370: "a8d311b114ec77ce",424: "25e43d52410aceac",488: "efee4e998669206e",5605: "fff606c4f8ef08bd",5996: "91d9b05f023e7c01",7292: "7582aa2a55eea3ff",9590: "25e43d52410aceac",}[chunkId] + ".css"
}